export default __webpack_public_path__ + "static/services-details1g-d931df20c867c7f1ddcd6fa43f13e20e.jpg";